// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1DxPz","label":"CategoryService_label__Y_YtB","location":"CategoryService_location__1y64m"};